import { RootState } from "../../store";

export const selectInterval = (state: RootState, key: string) => state.intervals.entities[key];
